export default __webpack_public_path__ + "static/media/FamilyPortrait400.1acac2a9.jpg";